export class IndividualPositionTypeReferenceModel {
    public individualPositionTypeCode: string;
    public individualPositionTypeName: string;
    public sortSequence: number;
}